<template>
  <!-- 供应商指令-->
  <div class="logisticsReceiptList">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @departmentChange="departmentChange"
      @partnerChange="partnerChange"
      @entrustingPartyChange="entrustingPartyChange"
    ></SiruiSearch>

    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.field === 'attNum'">
              <i v-if="scope.row[item.field] > 0" class="el-icon-paperclip color"></i>
            </span>
            <span v-else-if="item.field === 'inboundNo'">
              <a @click.stop="jumpToView(scope)" href="#">{{ scope.row[item.field] }}</a>
            </span>
            <span v-else-if="item.field === 'inboundStatus'">
              <p v-if="scope.row[item.field] == '01'">{{
                $t('logistics.logisticsReceiptList.overSave')
              }}</p>
              <p v-else-if="scope.row[item.field] == '02'">{{
                $t('logistics.logisticsReceiptList.overDoIt')
              }}</p>
              <p v-else-if="scope.row[item.field] == '03'">{{
                $t('logistics.logisticsReceiptList.getUp')
              }}</p>
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <!-- 供应商发货指令弹框 -->
    <search-table ref="searchTable"></search-table>
    <!-- 拷贝退换货单弹框 -->
    <return-order ref="returnOrderTable"></return-order>
    <!-- 库存调拨单弹框 -->
    <stock-order ref="stockOrderTable"></stock-order>
    <!--批量上传 -->
    <SiruiUpload ref="siruiUpload" @getData="getData" :action="action" :data="importData" />
  </div>
</template>
<script>
  // import axios from 'axios';
  import { mapState } from 'vuex';
  import API from '@/api/logisticsCenter/logisticsReceiptList.js';
  import BASEAPI from '@/api/dataBase.js';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import SearchTable from './components/searchTable';
  import SiruiUpload from '@/components/SiruiUpload';
  import ReturnOrder from './components/returnOrderTable';
  import StockOrder from './components/stockOrderTable';
  import tableMixins from '@/common/mixins/table.js';
  export default {
    components: {
      SiruiTable,
      SiruiSearch,
      SearchTable,
      ReturnOrder,
      SiruiUpload,
      StockOrder,
    },
    name: 'logisticsReceiptList',
    mixins: [tableMixins],
    data() {
      return {
        WarehousingList: [], //入库类型列表
        WarehousingStaticList: [
          {
            value: '01',
            label: this.$t('logistics.logisticsReceiptList.overSave'),
          },
          {
            value: '02',
            label: this.$t('logistics.logisticsReceiptList.overDoIt'),
          },
          {
            value: '03',
            label: this.$t('logistics.logisticsReceiptList.getUp'),
          },
        ], //入库状态列表
        ManagementType: [],
        load: false,
        query: {
          inboundNo: null, //物流入库单号
          inboundType: null, //入库类型
          inboundStatus: null, //入库单状态
          purchaseContractNo: null, //采购合同号
          productNo: null, //商品
          inboundStartDate: null, //入库日期起
          inboundEndDate: null, //入库日期止
          companyCode: null,
          companyName: null, //公司
          inboundDepartmentNo: null, //部门
          salesmanNo: null, //业务员
          inboundCreatePerson: null, //制单人
          partnerNo: null, //供应商
          partnerName: null, //供应商
          entrustingPartyNo: null, //委托方
          entrustingPartyName: null,
          storageNo: null, //仓库编码
          businessPattern: null, //经营类型
          shippingInstructionNo: null, //发货指令号
          productNoList: [],
          salesmanNoList: [],
          inboundCreatePersonList: [],
          storageNoList: [],
          externalNo: null, // 外部合同号
          distributionBatchNo: null,
        },
        multipleSelection: [], //存放选中的值
        departmentList: [], //部门列表
        trainWays: [], //运输方式列表
        menuButtonList: [],
        tableData: [],
        columnList: [],
        columnListDefault: [
          {
            field: 'attNum',
            title: 'logistics.logisticsReceiptList.attNum',
            visible: true,
          },
          {
            field: 'inboundNo',
            title: 'logistics.logisticsReceiptList.inboundNo',
            visible: true,
          },
          {
            field: 'inboundTypeName',
            title: 'logistics.logisticsReceiptList.inboundType',
            visible: true,
          },
          {
            field: 'inboundStatus',
            title: 'logistics.logisticsReceiptList.inboundStatus',
            visible: true,
          },
          {
            field: 'purchaseContractNo',
            title: 'logistics.logisticsReceiptList.purchaseContractNo',
            visible: true,
          },
          {
            field: 'productName',
            title: 'logistics.logisticsReceiptList.searchTableSpec',
            visible: true,
          },
          {
            field: 'inboundDate',
            title: 'logistics.logisticsReceiptList.inboundDate',
            visible: true,
          },
          {
            field: 'inboundQuantity',
            title: '物流入库数量',
            visible: true,
          },
          {
            field: 'companyName',
            title: 'logistics.logisticsReceiptList.companyName',
            visible: true,
          },
          {
            field: 'inboundDepartmentName',
            title: 'logistics.logisticsReceiptList.inboundDepartmentNo',
            visible: true,
          },
          {
            field: 'salesmanName',
            title: 'logistics.logisticsReceiptList.salesmanNoList',
            visible: true,
          },
          {
            field: 'inboundCreatePersonName',
            title: 'logistics.logisticsReceiptList.makeOrderPerson',
            visible: true,
          },
          {
            field: 'partnerName',
            title: 'logistics.logisticsReceiptList.givePerson',
            visible: true,
          },
          {
            field: 'entrustingPartyName',
            title: 'logistics.logisticsReceiptList.requistPerson',
            visible: true,
          },
          {
            field: 'storageNo',
            title: '仓库编码',
            visible: true,
          },
          {
            field: 'storageName',
            title: 'logistics.logisticsReceiptList.warehouseName',
            visible: true,
          },
          {
            field: 'businessPropertyName',
            title: 'logistics.logisticsReceiptList.saleType',
            visible: true,
          },
          {
            field: 'purchaseContractNo',
            title: '采购合同号',
            visible: true,
          },
          {
            field: 'externalNo',
            title: '外部编号',
            visible: true,
          },
          {
            field: 'shippingInstructionNo',
            title: 'logistics.logisticsReceiptList.shippingInstructionNo',
            visible: true,
          },
          { field: 'distributionBatchNo', title: '物流批次号', visible: true },
        ],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      //上传地址
      action() {
        return API.IMPORT_DATA_API;
      },
      //导入额外参数
      importData() {
        return {
          tenantCode: this.userInfo.userInfo.tenantCode,
          companyCode: this.userInfo.userInfo.companyCode,
          companyName: this.userInfo.userInfo.companyName,
          departmentCode: this.userInfo.userInfo.departmentCode,
          departmentName: this.userInfo.userInfo.departmentName,
          belongTenantCode: this.userInfo.userInfo.tenantCode,
          dataGroup: this.$globalVar.dataGroup,
          access_token: this.userInfo.userInfo.access_token,
        };
      },
      //搜索字段
      searchColumns() {
        return [
          {
            prop: 'inboundNo',
            name: this.$t('logistics.logisticsReceiptList.inboundNo'),
            type: 'input',
          },
          {
            prop: 'inboundType',
            name: this.$t('logistics.logisticsReceiptList.inboundType'),
            type: 'select',
            options: this.WarehousingList,
          },
          {
            prop: 'inboundStatus',
            name: this.$t('logistics.logisticsReceiptList.inboundStatus'),
            type: 'select',
            options: this.WarehousingStaticList,
          },
          {
            prop: 'purchaseContractNo',
            name: this.$t('logistics.logisticsReceiptList.purchaseContractNo'),
            type: 'input',
          },
          {
            prop: 'externalNo',
            name: '外部编号',
            type: 'input',
          },
          {
            type: 'searchTableSpec',
            name: this.$t('logistics.logisticsReceiptList.searchTableSpec'),
            prop: 'productNoList',
            searchType: 'goodsDetail',
            isMultiple: true,
          },
          {
            prop: 'inboundStartDate',
            name: this.$t('logistics.logisticsReceiptList.inboundStartDate'),
            type: 'startDaterangePicker',
          },
          {
            prop: 'inboundEndDate',
            name: this.$t('logistics.logisticsReceiptList.inboundEndDate'),
            type: 'endDaterangePicker',
          },
          {
            prop: 'companyName',
            name: this.$t('logistics.logisticsReceiptList.companyName'),
            type: 'input',
            disabled: true,
            placeholder: `${this.userInfo.userInfo.companyName}`,
          },
          {
            prop: 'inboundDepartmentNo',
            name: this.$t('logistics.logisticsReceiptList.inboundDepartmentNo'),
            type: 'select',
            options: this.departmentList,
            changeMethod: 'departmentChange',
          },
          {
            type: 'searchTableSpec',
            prop: 'salesmanNoList',
            name: this.$t('logistics.logisticsReceiptList.salesmanNoList'),
            searchType: 'personnel',
            isMultiple: true,
          },
          {
            type: 'searchTableSpec',
            name: this.$t('logistics.logisticsReceiptList.makeOrderPerson'),
            prop: 'inboundCreatePersonList',
            searchType: 'personnel',
            isMultiple: true,
          },
          {
            type: 'searchTableSpec',
            name: this.$t('logistics.logisticsReceiptList.givePerson'),
            prop: 'partnerNo',
            searchType: 'supplier',
            isMultiple: true,
            extraData: {
              companyCode: this.query.companyCode,
              departmentCode: this.query.inboundDepartmentNo,
            },
            changeMethod: 'partnerChange',
            currentValue: this.query.partnerName,
          },
          {
            type: 'searchTableSpec',
            name: this.$t('logistics.logisticsReceiptList.requistPerson'),
            prop: 'entrustingPartyNo',
            searchType: 'customer',
            isMultiple: true,
            extraData: {
              companyCode: this.query.companyCode,
              departmentCode: this.query.inboundDepartmentNo,
            },
            changeMethod: 'entrustingPartyChange',
            currentValue: this.query.entrustingPartyName,
          },
          {
            type: 'searchTableSpec',
            name: this.$t('logistics.logisticsReceiptList.warehouseName'),
            prop: 'storageNoList',
            searchType: 'warehouse',
            isMultiple: true,
          },
          {
            prop: 'businessProperty',
            name: this.$t('logistics.logisticsReceiptList.saleType'),
            type: 'select',
            options: this.ManagementType,
          },
          {
            prop: 'shippingInstructionNo',
            name: this.$t('logistics.logisticsReceiptList.shippingInstructionNo'),
            type: 'input',
          },
          {
            prop: 'distributionBatchNo',
            name: '物流批次号',
            type: 'input',
            placeholder: '请输入物流批次号',
          },
        ];
      },
    },
    /**页面必要代码Start */
    mounted() {
      this.getButtonList();
      this.getData();
      this.getDecationary();
    },
    methods: {
      departmentChange() {
        // 切换公司
        (this.query.partnerNo = this.query.partnerName = null),
          (this.query.entrustingPartyNo = this.query.entrustingPartyName = null);
      },
      partnerChange(val) {
        let item = val.val;
        if (item && item.length > 0) {
          this.query.partnerNo = item[0].partnerCode;
          this.query.partnerName = item[0].partnerZhName;
        } else {
          this.query.partnerNo = this.query.partnerName = null;
        }
      },
      entrustingPartyChange(val) {
        let item = val.val;
        if (item && item.length > 0) {
          this.query.entrustingPartyNo = item[0].partnerCode;
          this.query.entrustingPartyName = item[0].partnerZhName;
        } else {
          this.query.entrustingPartyNo = this.query.entrustingPartyName = null;
        }
      },
      //获取数据
      getData() {
        this.query.companyCode = this.userInfo.userInfo.companyCode;
        this.query.companyName = this.userInfo.userInfo.companyName;
        let query = Object.assign({}, this.query);
        if (this.query.productNoList) {
          if (this.query.productNoList.length > 0) {
            // query.productNo =
            //   this.query.productNoList[0].productDetailCode || query.productNo;
            query.productNo =
              this.query.productNoList && this.query.productNoList[0]
                ? this.query.productNoList[0].allProductDetailCode
                  ? this.query.productNoList[0].allProductDetailCode
                  : this.query.productNoList[0].productDetailCode
                : '';
          }
        }
        if (this.query.salesmanNoList) {
          if (this.query.salesmanNoList.length > 0) {
            query.salesmanNo = this.query.salesmanNoList[0].id || query.salesmanNo;
          }
        }
        if (this.query.inboundCreatePersonList) {
          if (this.query.inboundCreatePersonList.length > 0) {
            query.inboundCreatePersonNo =
              this.query.inboundCreatePersonList[0].id || query.inboundCreatePersonNo;
          }
        }
        if (this.query.storageNoList) {
          if (this.query.storageNoList.length > 0) {
            query.storageNo = this.query.storageNoList[0].storageCode || query.storageNo;
          }
        }
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        this.load = true;
        this.$axios.post(API.GET_DATA_API, query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.list;
            this.tableData.forEach((val) => {
              this.WarehousingList.forEach((s) => {
                if (val.inboundType == s.value) {
                  val.inboundTypeName = s.label;
                }
              });
            });
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //点击按钮触发的方法
      chooseClick(type) {
        if (type == 'copyPoint') {
          this.$refs.searchTable.defaultVisible = true;
        } else if (type == 'copyComeBack') {
          this.$refs.returnOrderTable.defaultVisible = true;
        } else if (type == 'copyOrder') {
          this.$refs.stockOrderTable.defaultVisible = true;
        } else if (type == 'importExcel') {
          this.importLading();
        }
      },

      importLading() {
        this.$refs.siruiUpload.openDialog(true);
      },
      //双击事件
      dblclickEvent(value) {
        let path = {
          path: '/logistics/logisticsView',
          name: 'logisticsView',
          meta: {
            keepAlive: true,
            title: this.$t('logistics.logisticsReceiptList.logisticsView'),
          },
          query: {
            inboundNo: value.row.inboundNo,
            shippingInstructionNo: value.row.shippingInstructionNo,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //单击运单号
      jumpToView(val) {
        this.dblclickEvent(val);
      },
      //获取入库类型
      async getInboundType() {
        let params = {
          dictType: 'inbound_type',
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_DICTBYDATACODE, params);
        if (selectStatus.data.code == 0) {
          this.WarehousingList = selectStatus.data.data;
        }
      },
      //获取经营类型
      async getManagementType() {
        let params = {
          dictType: 'operation_mode',
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_DICTBYDATACODE, params);
        if (selectStatus.data.code == 0) {
          this.ManagementType = selectStatus.data.data;
        }
      },
      //获取部门
      async getDepartment() {
        const params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
          personCompanyCode: this.userInfo.userInfo.companyCode,
        };
        const selectStatus = await this.$axios.post(BASEAPI.GET_PERSON_API, params);
        this.departmentList = selectStatus.data.data.personDepartmentInfo;
        this.departmentList.forEach((item) => {
          item.value = item.personDepartmentCode;
          item.label = item.personDepartmentName;
        });
      },
      //获取运输方式
      async getTrainWays() {
        let params = {
          dictType: 'delivery_method',
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_DICTBYDATACODE, params);
        if (selectStatus.data.code == 0) {
          this.trainWays = selectStatus.data.data;
        }
      },
      //获取字典表
      getDecationary() {
        this.getManagementType();
        this.getInboundType();
        this.getDepartment();
        this.getTrainWays();
      },
    },
  };
</script>
<style lang="scss" scope>
  .logisticsReceiptList {
    // .el-dialog__header {
    //   padding: 14px 16px;
    //   border-bottom: 1px solid #e8eaec;
    //   // background: #5391da;
    //   // text-align: center;
    // }
    // .el-dialog__title {
    //   line-height: 24px;
    //   font-size: 18px;
    //   // color: white !important;
    // }
    // .el-dialog__headerbtn {
    //   top: 10px;
    // }
    // .el-icon-close:before {
    //   content: "\E6DB";
    //   // color: white;
    //   // font-size: 30px;
    // }
    .el-dialog {
      width: 1100px;
    }
    .color {
      color: #ffb77d;
    }
  }
</style>
